function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.144 2.575H5.4v50.987H2.144z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "square",
  strokeMiterlimit: 3.962
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.399 25.48s4.395-2.161 11.627-2.17c8.832.375 17.777 4.101 24.478 4.34 7.89.211 11.627-2.17 11.627-2.17V4.868s-5.279 2.233-11.627 2.17c-8.357-.085-14.7-4.244-24.478-4.34-7.074-.318-11.627 2.17-11.627 2.17z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "square",
  strokeMiterlimit: 3.962
});

var SvgFlag = function SvgFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Flag.89742bcd.svg";
export { ForwardRef as ReactComponent };